import { MRT_ColumnDef, MRT_RowData } from 'material-react-table';
import { useMemo, useState } from 'react';
import { Egreso, MaterialTransferido } from '@/shared/interfaces';
import { cellNotFilter, formatDateWithTime, useCheckPermissions } from '@/shared';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { PermissionsEnum } from '@/auth/interfaces';
import { Button, IconButton, Tooltip } from '@mui/material';
import { useFileDowloadDoc } from '@/shared/hooks/useDownloadFileDoc';
import { Download } from '@mui/icons-material';
import { useCargarSeriesProductos } from '@/store/erp/productos/useCargarSeriesProductos.store';
import InfoNumeroReferencia from '@/shared/components/ui/InfoNumeroReferencia/InfoNumeroReferencia';

export const useTableColumnsEgreso = () => {
  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  ///const [details, setDetails] = useState<MaterialTransferido[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  //**********hook */
  const { downloadFile } = useFileDowloadDoc()


  useCheckPermissions(PermissionsEnum.api_view_egresoinventario)


  const onDetails = (e: MRT_RowData) => {
    //setDetails(JSON.parse(JSON.stringify(e.productos)));
    handleCopiarLista(e.productos)
    setIsModalOpen(true);
  };
  //*******************function 
  const onDownload = (e: string, nameFile: string) => {
    console.log('url', e)
    downloadFile({
      url: e,
      nameFile: nameFile
    })

  }
  //COLUMNA BASE (Solicitud Transferencia de Inventario)
  const columnaBase = useMemo<MRT_ColumnDef<Egreso>[]>(() => [
    {
      ...cellNotFilter,
      accessorKey: 'url_pdf',
      header: "Reporte",
      size: 100,
      width: 50,
      Cell: ({ row }) => {
        return (
          <>
            <Tooltip title="Descargar">
              <IconButton
                onClick={() => onDownload(row.original.url_pdf!, `egreso_${row.original.numero_referencia}`)}
              >
                <Download color='secondary' />
              </IconButton>

            </Tooltip>
          </>

        )
      }
    },
    {
      ...cellNotFilter,
      accessorKey: "detalles",
      header: "productos",
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <>
            <Button
              variant='text'
              color='info'
              onClick={() => {
                onDetails(row.original);
              }}
              startIcon={<VisibilityIcon />}
            >
              {'Ver'}
            </Button>
          </>
        );
      },
    },
    {
      accessorKey: 'numero_referencia',
      header: 'N° referencia',
      size: 200,
    },
   
    {
      accessorKey: 'movimiento_inventario',
      header: '# Movimiento Kardex',
      size: 100,
      Cell: ({ row }) => {

        return <InfoNumeroReferencia
          movimiento_inventario_data={row.original.movimiento_inventario_data}
        />
      }
    },
    {
      ...cellNotFilter,
      accessorKey: 'motivo',
      header: 'MOTIVO EGRESO',
      size: 200,
      Cell: ({ row }) => (
        row.original.movimiento_inventario_data?.[0]?.motivo_data?.nombre != null ?
          row.original.movimiento_inventario_data?.[0]?.motivo_data?.nombre : '—'
      )
    },
    {
      accessorKey: 'observaciones.observacion_egreso',
      header: 'Observacion: ',
      size: 200,
       Cell: ({ row }) => {
        const obs = row.original?.observaciones?.observacion_egreso
        return obs?.trim() ? obs: 'Sin comentarios'}
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha',
      header: 'Fecha',
      size: 200,
      Cell: ({ row }) => (
        row.original.fecha != null ?
          formatDateWithTime(row.original.fecha_creacion) : '—'
      ),
    },

    {
      ...cellNotFilter,
      accessorKey: 'bodega_data.nombre',
      header: 'bodega'

    },
    {
      ...cellNotFilter,
      accessorKey: 'ubicacion_data.nombre',
      header: 'ubicacion'
    },
    {
      accessorKey: 'solicitud_egreso',
      header: 'solicitud egreso',
      size: 200,
      Cell: ({ row }) => (
        row.original.solicitud_egreso != null ?
          row.original.solicitud_egreso : '—'
      )
    },

    {
      accessorKey: 'unidad_transporte',
      header: 'Unidad transporte',
      size: 200,
      Cell: ({ row }) => (
        row.original.unidad_transporte != null ?
          row.original.unidad_transporte : '—'
      )
    },

  ], [])

  const columnsProductosDetallePedidosDb: MRT_ColumnDef<MaterialTransferido>[] =
    useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
      () => [
        {
          accessorKey: 'codigo',
          header: 'Código',
          Cell: ({ row }) => row.original?.codigo || '—',
        }, {
          accessorKey: 'cantidad',
          header: 'Cant. Requerida'
        }, {
          accessorKey: 'cantidad_aprobada',
          header: 'Cant. Aprobada',
          Cell: ({ row }) => row.original?.cantidad_aprobada || '—'
        },
        {
          accessorKey: 'producto_data.descripcion',
          header: 'Descripción',
          Cell: ({ row }) => row.original?.producto_data?.descripcion || '—',
        },

        {
          accessorKey: 'producto_data.stock_actual',
          header: 'Stock Actual',
          Cell: ({ row }) => row.original?.producto_data?.stock_actual || '—',
        },
        {
          accessorKey: 'producto_data.modelo_producto',
          header: 'Modelo',
        },
        {
          accessorKey: 'producto_data.marca_producto',
          header: 'Marca',
        },
        {
          accessorKey: 'producto_data.categoria_producto',
          header: 'Categoria',
        },
        {
          accessorKey: 'producto_data.unidad_medida',
          header: 'Medida',
          Cell: ({ row }) => row.original.producto_data?.unidad_medida || '—'
        },
      ],
      []
    );

  return {
    columnaBase,
    columnsProductosDetallePedidosDb,
    isModalOpen,
    setIsModalOpen,
    onDetails,
  }
};
